import React, { useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { X, ArrowRight } from 'lucide-react';

const VideoLightbox = ({ item, onClose }) => {
  const navigate = useNavigate();

  useEffect(() => {
    const onKey = (e) => { if (e.key === 'Escape') onClose(); };
    document.addEventListener('keydown', onKey);
    return () => document.removeEventListener('keydown', onKey);
  }, [onClose]);

  useEffect(() => {
    const original = document.body.style.overflow;
    document.body.style.overflow = 'hidden';
    return () => { document.body.style.overflow = original; };
  }, []);

  if (!item?.video_id) return null;

  const title = item.category ? item.category.name : item.subcategory ? item.subcategory.name : item.product?.name;
  const subtitle = (item.category || item.subcategory) ? null : `৳${Number(item.product?.price || 0).toLocaleString()}`;

  const goToTarget = () => {
    if (item.category) navigate(`/category/${item.category.id}`);
    else if (item.subcategory) navigate(`/subcategory/${item.subcategory.id}`);
    else if (item.product) navigate(`/product/${item.product.id}`);
    onClose();
  };

  return (
    <div className="fixed inset-0 z-[60] bg-black flex flex-col">
      {/* Header */}
      <div className="flex items-center justify-between px-4 sm:px-6 py-4 shrink-0 relative z-10">
        <div className="min-w-0">
          <p className="text-white text-sm font-medium truncate">{title}</p>
          {subtitle && <p className="text-white/60 text-xs">{subtitle}</p>}
        </div>
        <button
          onClick={onClose}
          className="p-2 text-white/70 hover:text-white hover:bg-white/10 rounded-full transition-colors shrink-0"
          aria-label="Close"
        >
          <X className="w-6 h-6" />
        </button>
      </div>

      {/* Video */}
      <div className="flex-1 flex items-center justify-center min-h-0 px-0 sm:px-4">
        <div className="relative h-full w-full sm:max-w-md sm:aspect-[9/16] sm:h-auto">
          <iframe
            key={item.video_id}
            src={`https://www.youtube.com/embed/${item.video_id}?autoplay=1&mute=0&playsinline=1&rel=0&modestbranding=1`}
            title={title}
            className="w-full h-full"
            allow="autoplay; encrypted-media; picture-in-picture"
            allowFullScreen
            frameBorder="0"
          />
        </div>
      </div>

      {/* Footer CTA */}
      <div className="shrink-0 px-4 sm:px-6 py-4 flex justify-center">
        <button
          onClick={goToTarget}
          className="flex items-center gap-2 px-5 py-2.5 bg-white text-gray-900 text-sm font-semibold rounded-full hover:bg-gray-100 transition-colors"
        >
          {item.category ? 'View Category' : item.subcategory ? 'View Sub-Category' : 'View Product'}
          <ArrowRight className="w-4 h-4" />
        </button>
      </div>
    </div>
  );
};

export default VideoLightbox;
